export default "__VITE_ASSET__DTpV7dwK__"